import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import WhereForeverBegins from "./sections/WhereForeverBegins";
import TheVowPhilosophy from "./sections/TheVowPhilosophy";
import OurSignatureSpaces from "./sections/OurSignatureSpaces";
import TheVowExperience from "./sections/TheVowExperience";
import VoicesOfLove from "./sections/VoicesOfLove";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <WhereForeverBegins />
      <TheVowPhilosophy />
      <OurSignatureSpaces />
      <TheVowExperience />
      <VoicesOfLove />
      <Footer />
    </div>;
}